

<template>
<div>
<v-container>
<v-row>
<v-col cols="12" sm="12" lg="12">
   <producto></producto>
</v-col>
</v-row>   
</v-container>
   
</div>
</template>

<script>

import producto from '@/components/tienda/producto/Producto.vue';



export default {
    data () {
    return {
              
    }
  },
  components: {
    
    producto
    
  },

  methods: {

}

}
    

</script>


